import React from 'react';
import { motion } from 'framer-motion';

const RewardBadge = ({ type }) => {
  // Badge configurations
  const badges = {
    'first-step': {
      title: 'First Step',
      description: 'Started your journey',
      icon: '[ROCKET]',
      color: 'bg-blue-100 text-blue-800 border-blue-200'
    },
    'halfway': {
      title: 'Halfway There',
      description: 'Profile 50% complete',
      icon: '🏆',
      color: 'bg-yellow-100 text-yellow-800 border-yellow-200'
    },
    'skill-collector': {
      title: 'Skill Collector',
      description: 'Added 5+ skills',
      icon: '🛠️',
      color: 'bg-green-100 text-green-800 border-green-200'
    },
    'resume-ready': {
      title: 'Resume Ready',
      description: 'Uploaded your resume',
      icon: '📄',
      color: 'bg-purple-100 text-purple-800 border-purple-200'
    },
    'all-star': {
      title: 'All Star',
      description: 'Completed your profile',
      icon: '⭐',
      color: 'bg-pink-100 text-pink-800 border-pink-200'
    }
  };
  
  // Get badge info or use default
  const badge = badges[type] || {
    title: 'Achievement',
    description: 'You earned a badge',
    icon: '🎯',
    color: 'bg-gray-100 text-gray-800 border-gray-200'
  };
  
  return (
    <motion.div
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      transition={{ 
        type: "spring", 
        stiffness: 260, 
        damping: 20 
      }}
      className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium border ${badge.color}`}
      whileHover={{ scale: 1.05 }}
    >
      <span className="mr-1">{badge.icon}</span>
      <span>{badge.title}</span>
      <span className="sr-only">{badge.description}</span>
    </motion.div>
  );
};

export default RewardBadge;
